import { call, takeEvery, put, select } from 'redux-saga/effects'
import { stopSubmit, startSubmit } from 'redux-form/immutable'
import { ADMIN_WELCOME_EMAIL_FORM as formName } from 'app/constants/adminWelcomeEmail'
import { ADMIN_WELCOME_EMAIL } from '../actionTypes'
import makeAPIRequest from 'store/entities/api/sagas'
import { ADMIN_WELCOME_EMAIL_PATH, SUPER_ADMIN_WELCOME_EMAIL_PATH } from 'app/constants/api/adminWelcomeEmail'
import { getOrganizationUsersOrganizationId } from 'store/entities/organizations/selectors'
import * as ROLES from 'app/constants/roles'
import { getIdentityActiveRoleName } from 'store/entities/identity/selectors'
import { PUT } from 'app/constants/requests'
import { adminWelcomeEmail } from '../actions'
import { showSuccess, showError } from 'store/entities/toastr/utils'
import { WELCOME_EMAIL_SAVED } from 'app/constants/toastrMessages'

export default function* saveAdminWelcomeEmailSaga() {
  yield takeEvery(ADMIN_WELCOME_EMAIL.PUT.REQUEST, handleSaveWelcomeEmailRequest)
}

export function* handleSaveWelcomeEmailRequest({ payload }) {
  try {
    yield put(startSubmit(formName))
    const roleName = yield select(getIdentityActiveRoleName)
    const orgId = yield select(getOrganizationUsersOrganizationId)
    const path = roleName === ROLES.ADMIN ? ADMIN_WELCOME_EMAIL_PATH : SUPER_ADMIN_WELCOME_EMAIL_PATH(orgId)
    const response = yield call(makeAPIRequest, path, {
      method: PUT,
      data: payload.data.toJS(),
    })
    yield put(adminWelcomeEmail.put.success(response.data.data))
    showSuccess({ content: WELCOME_EMAIL_SAVED })
  } catch (badResponse) {
    showError()
    yield put(adminWelcomeEmail.post.fail())
  } finally {
    yield put(stopSubmit(formName))
  }
}
